export default __webpack_public_path__ + "fa5b5fdc50b8f79cbcdffe837ae94e4e.png";